import request from '@/axios/axios'

// 产品品类查询
export function category() {
  return request({
    url: '/device/v1/product/categories',
    method: 'get'
  })
}

// 获取客户信息
export function customer() {
  return request({
    url: '/device/v1/product/customer',
    method: 'get'
  })
}

// 获取联网方式和配网方式
export function scheme() {
  return request({
    url: 'device/v1/product/comm/scheme',
    method: 'get'
  })
}

// 创建产品
export function createProduct(params) {
  return request({
    url: 'device/v1/product/add',
    method: 'post',
    data: params
  })
}

// 列表查询产品信息
export function product(query) {
  return request({
    url: 'device/v1/product/list',
    method: 'post',
    data: query
  })
}

// 获取设备分类
export function deviceCategories() {
  return request({
    url: 'device/v1/device/categories',
    method: 'get'
  })
}
